module.exports = __webpack_public_path__ + "img/blue_005.a69414da.png";